import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagesComponent } from './pages.component';
import { HomeComponent } from './home/home.component';
import { AuthorizationGuard } from '../guards/authorization.guard';
import { AuthenticationGuard } from '../guards/authentication.guard';

const routes: Routes = [
  {
    path: "",
    component: PagesComponent,
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: "home",
        component: HomeComponent
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
        canActivate: [AuthorizationGuard],
        canActivateChild: [AuthorizationGuard]
      },
      {
        path: 'consortium',
        loadChildren: () => import('./consortium/consortium.module').then(m => m.ConsortiumModule),
        // canActivate: [AuthorizationGuard],
        // canActivateChild: [AuthorizationGuard]
      },
      {
        path: 'bank',
        loadChildren: () => import('./bank/bank.module').then(m => m.BankModule),
        canActivate: [AuthorizationGuard],
        canActivateChild: [AuthorizationGuard]
      },
      {
        path: 'insurance',
        loadChildren: () => import('./insurance/insurance.module').then(m => m.InsuranceModule),
        canActivate: [AuthorizationGuard],
        canActivateChild: [AuthorizationGuard]
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
        canActivate: [AuthorizationGuard],
        canActivateChild: [AuthorizationGuard]
      },
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
      },
      {
        path: '**',
        redirectTo: '/home',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
